// prefer default export if available
const preferDefault = m => m && m.default || m;

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../.cache/caches/gatsby-plugin-offline/app-shell.js"
  /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */
  ),
  "component---src-components-templates-project-jsx": () => import("./../../src/components/templates/Project.jsx"
  /* webpackChunkName: "component---src-components-templates-project-jsx" */
  ),
  "component---src-pages-404-jsx": () => import("./../../src/pages/404.jsx"
  /* webpackChunkName: "component---src-pages-404-jsx" */
  ),
  "component---src-pages-artist-jsx": () => import("./../../src/pages/artist.jsx"
  /* webpackChunkName: "component---src-pages-artist-jsx" */
  ),
  "component---src-pages-entrepreneur-jsx": () => import("./../../src/pages/entrepreneur.jsx"
  /* webpackChunkName: "component---src-pages-entrepreneur-jsx" */
  ),
  "component---src-pages-index-jsx": () => import("./../../src/pages/index.jsx"
  /* webpackChunkName: "component---src-pages-index-jsx" */
  ),
  "component---src-pages-inventor-jsx": () => import("./../../src/pages/inventor.jsx"
  /* webpackChunkName: "component---src-pages-inventor-jsx" */
  ),
  "component---src-pages-resume-jsx": () => import("./../../src/pages/resume.jsx"
  /* webpackChunkName: "component---src-pages-resume-jsx" */
  ),
  "component---src-pages-writer-jsx": () => import("./../../src/pages/writer.jsx"
  /* webpackChunkName: "component---src-pages-writer-jsx" */
  )
};